import { z } from 'zod/v4';
import { TRACING_AI_ANALYSIS_TYPES } from '../../constants.js';

/**
 * The per-chunk result message tracing-ai publishes back per transaction/link.
 * `cancelled` marks a short-circuited (cancelled) chunk so the platform excludes
 * it from the reuse cache and credits.
 */
export const ChunkResultMessageSchema = z.object({
  aiSummaryId: z.string(),
  chunkId: z.string(),
  type: z.enum([
    TRACING_AI_ANALYSIS_TYPES.CLASSIFY,
    TRACING_AI_ANALYSIS_TYPES.ANALYZE,
    TRACING_AI_ANALYSIS_TYPES.VALIDATE,
  ]),
  success: z.boolean(),
  result: z.unknown().nullable(),
  cancelled: z.boolean().optional(),
});

export type IChunkResultMessage = z.infer<typeof ChunkResultMessageSchema>;
